<template>
  <div class="access-instructions-overview">
    <el-card>
      <template #header>
        <div class="card-header">
          <el-icon><Compass /></el-icon>
          <span>概述概要</span>
        </div>
      </template>
      <div class="card-content">
        <!-- 修改此处，添加 style 来设置字体大小 -->
        <p style="font-size: 24px;"><strong>该说明文档旨在帮助开发者快速接入FOS开放平台。</strong></p>
        <hr class="custom-hr">
        <!-- 新增接入步骤说明 -->
        <p>接入步骤说明：</p>
        <el-steps :active="3" align-center>
          <el-step title="平台配置" description="配置accessKey和objectKey"></el-step>
          <el-step title="通行密钥" description="通过临时密钥获取通行秘钥，需要本地存储"></el-step>
          <el-step title="文件操作" description="通过HTTP请求接口操作文件"></el-step>
        </el-steps>
        <!-- 为该段落添加一个类名以便设置样式 -->
        <p class="new-user-trial-text">新注册用户可免费获取试用额度：</p>
        <el-table border :data="[newUserUsage]" stripe>
          <el-table-column prop="uploadTimes" label="上传次数"></el-table-column>
          <el-table-column prop="downloadTimes" label="下载次数"></el-table-column>
          <el-table-column prop="queryTimes" label="查询次数"></el-table-column>
          <el-table-column prop="deleteTimes" label="删除次数"></el-table-column>
        </el-table>
      </div>
      <!-- 修改底部链接部分 -->
      <div class="access-instructions-footer">
        <router-link to="/access-instructions/config-generation" class="next-document-link">
          配置生成 <el-icon><ArrowRight /></el-icon>
        </router-link>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ArrowRight, Compass } from '@element-plus/icons-vue';
import { ref } from 'vue';

const newUserUsage = ref({
  uploadTimes: 50,
  downloadTimes: 50,
  queryTimes: 500,
  deleteTimes: 20
});
// 引入公共样式
import '@/styles/common-access-instructions.css'
</script>

<style scoped>
.access-instructions-overview {
  padding: 20px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
}

.card-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.card-content table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.card-content th,
.card-content td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}

/* 新增分割线样式 */
.custom-hr {
  border: none;
  border-top: 1px solid #ebeef5; /* 淡颜色，与 ElementUI 分割线一致 */
  margin: 20px 0; /* 上下间距 20px */
}

/* 为新注册用户试用文案添加上边距 */
.new-user-trial-text {
  margin-top: 40px;
}
</style>